<template>
  <div class="header">
    <router-link to="/">
      <h1>iKnowMagic <img src="@/assets/images/zen.svg" alt="iknowmagic"></h1>
      <h2>A portfolio of Ilan Kaim</h2>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue